import moment from "moment-timezone";
import { getSystemTimezone } from "./getSystemTimezone";
export const getWeekNoOfMonth = (date, timezone = getSystemTimezone()) => {
    const mDate = moment(date).tz(timezone);
    const startOfMonth = mDate.clone().startOf('month');
    return Math.ceil(mDate.diff(startOfMonth, 'weeks', true));
};
